module.exports = __webpack_public_path__ + "img/banner_sample_pc.b7a4ac11.jpg";